// extracted by mini-css-extract-plugin
module.exports = {"roleItem":"lmsmUZzACBz1FIzkbw1qQ","roleItemSelected":"_1iH4skA-UsvkwqKXt5EPuu","roleContent":"_3soFKnLTg9-oNZDkyzmJzM","checkArea":"_2xMlhT9tg_qcRh0mOemS65"};